/*
 * @ProjectName: Union Service
 * @FileName:
 * @PackageName:
 * @Author:
 * @Date: 2020-07-06 14:16:23
 * @LastEditTime: 2020-08-24 11:01:19
 * @LastEditors: Zhanglei
 * @Description:
 * @FilePath: /desktop/src/store/index.js
 * @copyright(c) 2017-2020 BMW Brilliance Automotive Co., Ltd.
 */
import Vue from "vue";
import Vuex from "vuex";

import user from "./modules/user";
import languages from "./modules/languages";
import menu from "./modules/menu";
import account from "./modules/account";
import template from "./modules/template";
import group from "./modules/group";
import endpoint from "./modules/endpoint";
import permission from "./modules/permission";
import action from "./modules/action";
import domain from "./modules/domain";
import role from "./modules/role";
import unit from "./modules/unit";
import config from "./modules/config";
import audit from "./modules/audit";
import tagsView from "./modules/tagsView";
import getters from "./getters";
import feeAudit from "./modules/feeAudit";
import newlyMarried from "./modules/newlyMarried";
import union from "./modules/union";
import welfare from "./modules/welfare";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    menu,
    languages,
    user,
    account,
    template,
    endpoint,
    group,
    domain,
    action,
    role,
    audit,
    unit,
    config,
    permission,
    feeAudit,
    newlyMarried,
    union,
    tagsView,
    welfare
  },
  getters
});
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js